import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export default function useSectionNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (item) => {
      if (item.to) {
        if (pathname !== item.to) navigate(item.to);
        else if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      if (pathname !== "/") {
        navigate("/");
        setTimeout(() => scrollToId(item.id), 450);
      } else {
        scrollToId(item.id);
      }
    },
    [pathname, navigate]
  );
}
